// extracted by mini-css-extract-plugin
export default {"header":"help-center_header__1Y9-V","title":"help-center_title__ch_6V","wrap":"help-center_wrap__uTWgf","content":"help-center_content__3zZxf"};